export interface IScore {
  min: number;
  max: number;
  text: string;
}

export const ADHD_MAX_SCORE = 6;
export const ADHD_SCORES = [
  {
    min: 0,
    max: 3,
    text: 'Not indicative of Adult ADHD symptoms'
  },
  {
    min: 4,
    max: 6,
    text: 'Indicative of Adult ADHD symptoms'
  }
] as IScore[];
